export enum BookingsOrdersApiMethods {
    getBookingOrders = 'BookingOrders.GetBookingOrders',
    getBookings = 'Bookings.GetBookings',
    getBookingOrder = 'BookingOrders.GetBookingOrder',
    ordersCancelOrderPayment = "BookingOrders.CancelBookingOrderPayment",
    createBookingOrder = "BookingOrders.CreateBookingOrder",
    updateBookingOrderStatus = "BookingOrders.UpdateBookingOrderStatus"

}
